import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const articleSlugs = [
  "vigorbuy-spreadsheet-guide",
  "vigorbuy-spreadsheet-safety",
  "vigorbuy-spreadsheet-shipping",
  "vigorbuy-spreadsheet-deals",
  "vigorbuy-spreadsheet-categories",
  "vigorbuy-spreadsheet-vs-traditional",
  "vigorbuy-spreadsheet-tips",
  "vigorbuy-spreadsheet-shopping-list",
  "vigorbuy-spreadsheet-smart-shopper",
  "vigorbuy-spreadsheet-beginners",
  "vigorbuy-spreadsheet-updates",
  "vigorbuy-spreadsheet-product-comparison",
];

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  // Old guide route - redirect handled inside component
  {
    path: "/vigorbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  // New article routes
  ...articleSlugs.map((slug) => ({
    path: `/article/${slug}`,
    element: <ArticlePage />,
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;